<template lang="html">
  <div class="access-denied-container">
    <div class="access-card">
      <i class="fa fa-exclamation-triangle warning-icon"></i>
      <h1>Aucun accès disponible</h1>
      <p>Il semble que vous n'ayez accès à aucune page pour le moment.</p>
      <p>Veuillez contacter un administrateur Pour recevoir les permissions nécéssaire à votre usage.</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "CanNotAccess"
};
</script>


<style scoped>
.access-denied-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.access-card {
  text-align: center;
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.warning-icon {
  font-size: 50px;
  color: #dc9135;
  margin-bottom: 10px;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

p {
  font-size: 16px;
  color: #555;
  margin-bottom: 15px;
}

</style>
  
